export default __webpack_public_path__ + "static/media/alpha-numeric.447db05c.svg";